import { Context } from "@/ui-components/utils/root/context";
import { useContext } from "react";

export const useUser = () => {
  const { user } = useContext(Context);
  return { user };
};
